import React from "react";
import PropTypes from "prop-types";
import { intlShape } from "react-intl";
import CategoryInfo from "./CategoryInfo";

const CategoryList = ({ trs, intl }) => {
  const { categoryList, totalRewards } = trs.detail;
  return (
    <div className="trs-category-list">
      {categoryList &&
        categoryList.map(item => {
          return (
            <CategoryInfo
              key={item.categoryName}
              data={item}
              currencyCode={totalRewards.currency}
              intl={intl}
            />
          );
        })}
    </div>
  );
};
CategoryList.propTypes = {
  trs: PropTypes.object,
  intl: intlShape.isRequired,
};

export default CategoryList;



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/CategoryList.jsx